export default {
  app: {
    privacy: {
      policy: 'Datenschutzrichtlinie',
      expansive: 'Durch die Nutzung von Expansive stimmen Sie der Expansive {action} zu',
      client: '@:app.privacy.expansive{lineBreak}& {clientName} {clientAction}',
    },
    sessionExpired: 'Sitzung abgelaufen',
    sessionExpiredDescription:
      'Ihre Sitzung ist abgelaufen. Bitte melden Sie sich erneut an, um die Anwendung weiter zu nutzen.',
  },
  components: {
    appContainer: {
      chooseLanguage: 'Sprache wählen',
      chooseLanguageDescription:
        'Wählen Sie Ihre bevorzugte Sprache für die Anwendung. Dadurch ändert sich die Sprache der Benutzeroberfläche und des Inhalts.',
    },
    userSelection: {
      cancel: 'Abbrechen',
      createNewUser: 'Ihr Name ist nicht aufgeführt',
      newUser: 'Neuer Benutzer',
      selectAnExistingUser: 'Vorhandenen Benutzer auswählen',
      selectUserHint:
        'Wählen Sie einen bestehenden Benutzer aus oder erstellen Sie einen neuen, um fortzufahren.',
      startTypingToSearch: 'Tippen Sie, um zu suchen...',
    },
    verification: {
      codeVerification: {
        continue: 'Weiter',
        header: 'Standortzugangscode eingeben',
        invalidCode: 'Ungültiger Code, bitte versuchen Sie es erneut.',
      },
      geoVerification: {
        continueWithoutVerifying: 'Ohne Standortüberprüfung fortfahren',
        enterSiteAccessCode: 'Standortzugangscode eingeben',
        locationNotEnabledOrAvailable: 'Warum sehe ich das?',
        notAvailable: {
          description: 'GPS-Standort wird auf diesem Gerät nicht unterstützt.',
          header: 'Standort nicht unterstützt',
        },
        notEnabled: {
          description:
            'Standortdienste sind nicht aktiviert oder die Berechtigung wurde nicht erteilt.',
          header: 'Standort nicht aktiviert',
        },
        notVerified: {
          description: 'GPS zeigt an, dass Sie sich nicht vor Ort befinden.',
          header: 'Standort nicht verifiziert',
        },
        tryAgain: 'Erneut versuchen',
        unavailable: {
          description: 'Wir konnten Ihren GPS-Standort nicht verifizieren.',
          header: 'Standort nicht verfügbar',
        },
        unknown: {
          description: 'Wir können Ihren Standort nicht bestimmen.',
          header: 'Standort unbekannt',
        },
        verified: {
          description: 'GPS zeigt an, dass Sie sich vor Ort befinden.',
          header: 'Standort verifiziert',
        },
      },
    },
    workOrder: {
      assets: {
        emptyTitle: 'Keine Anlagen gefunden',
        emptyDescription: 'Für diesen Arbeitsauftrag sind keine Anlagen vorhanden.',
        warrantyParts: 'Teilegarantie läuft ab',
        serialNumber: 'Seriennummer',
        none: '<keine>',
      },
      updates: {
        emptyTitle: 'Keine Updates gefunden',
        emptyDescription: 'Für diesen Arbeitsauftrag gibt es keine Updates.',
        unknownUser: 'Unbekannter Benutzer',
        none: 'Keine',
        addComment: {
          buttonLabel: 'Kommentar hinzufügen',
        },
      },
      startWorkCheck: {
        startWorkCheckList: {
          hazards: 'Gefahren',
          no: 'Nein',
          yes: 'Ja',
        },
      },
    },
    attachmentsList: {
      attachments: 'Anhänge',
      documents: 'Dokumente',
      siteDocuments: 'Standortdokumente',
    },
  },
  stores: {
    authenticated: {
      startWorkCheckStore: {
        hazards: 'Gefahren',
        induction: 'Einweisung',
        safeToProceed: 'Sicher fortzufahren',
      },
    },
  },
  views: {
    authenticated: {
      sessions: {
        dueBy: 'Fälligkeitsdatum',
        activeSessions: 'Aktive Sitzungen',
        activeSessionsDescription:
          'Sie sind bereits bei den folgenden Arbeitsaufträgen eingecheckt. Sie müssen diese Arbeitsaufträge auschecken, bevor Sie sich bei einem neuen einchecken.',
        resumeSession: 'Fortsetzen',
        startTime: 'Gestartet um',
        unexpectedErrorTitle: 'Unerwarteter Fehler',
        unexpectedErrorMessage:
          'Beim Erstellen Ihrer Sitzungen ist ein unerwarteter Fehler aufgetreten. Bitte versuchen Sie es später erneut.',
        engineerNotFound: 'Ingenieur nicht gefunden',
        engineerNotFoundDescription:
          'Der Ingenieur, den Sie einchecken möchten, ist im System nicht vorhanden. Bitte wenden Sie sich an Ihren Administrator.',
      },
      verification: {
        code: {
          description:
            'Um einzuchecken, holen Sie bitte den 4-stelligen Code vom Standortleiter oder der zuständigen Kontaktperson ein.',
        },
        geo: {
          continue: 'Weiter',
        },
      },
      workOrders: {
        checkout: {
          index: {
            signOff:
              'Bitte holen Sie den Zugangscode beim Standortleiter oder der beauftragten Kontaktperson ein, um Ihren Besuch abzuschließen.',
            checkOut: 'Auschecken',
            completeBeforeLeaving: 'Bitte füllen Sie das folgende Formular aus, bevor Sie gehen.',
            continue: 'Weiter',
            noResolutionSelected: 'Bitte wählen Sie eine Lösung, bevor Sie fortfahren.',
            quoteRequired: {
              hint: 'Besuch abgeschlossen, Angebot folgt',
              label: 'Angebot erforderlich',
            },
            returnVisitRequired: {
              hint: 'Wir werden erneut zurückkehren, um abzuschließen',
              label: 'Rückkehr erforderlich',
            },
            serviceCompleted: {
              hint: 'Keine weiteren Maßnahmen erforderlich',
              label: 'Service abgeschlossen',
            },
            uploadCheckout: 'Datei, Foto oder Video hochladen',
            visitNotes: 'Besuchsnotizen',
            workOrderResolution: 'Arbeitsauftrag-Lösung',
            enterNotes: 'Geben Sie hier Notizen ein...',
            errors: {
              timedOut: 'Zeitüberschreitung, mehr als 30 Sekunden. Bitte versuchen Sie es erneut.',
              closingSession: 'Fehler beim Schließen der Sitzung',
            },
          },
          success: {
            description:
              'Vielen Dank für Ihren Besuch bei {site}. | {site} hat noch 1 offenen Arbeitsauftrag. | {site} hat noch {count} offene Arbeitsaufträge.',
            endVisit: 'Besuch beenden',
            header: 'Sie haben erfolgreich ausgecheckt',
            viewWorkOrders: 'Bei einem anderen Arbeitsauftrag einchecken',
          },
          verification: {
            code: {
              description:
                'Um auszuchecken, holen Sie bitte den 4-stelligen Code vom Standortleiter oder der zuständigen Kontaktperson ein.',
              continue: 'Weiter',
            },
            geo: {
              checkOut: 'Auschecken',
              continue: 'Weiter',
            },
          },
        },
        detail: {
          assets: 'Anlagen',
          call: 'Anrufen',
          checkOut: 'Auschecken',
          closed: 'Geschlossen',
          details: 'Details',
          dueBy: 'Fälligkeitsdatum',
          manageEngineers: 'Ingenieure verwalten',
          notAvailable: 'Nicht verfügbar',
          pointOfContact: 'Ansprechpartner',
          siteAccessTimes: 'Zutrittszeiten',
          siteAccessInstructions: 'Zugangsanweisungen',
          siteAddress: 'Standortadresse',
          siteNotes: 'Standortnotizen',
          siteTelephone: 'Standorttelefon',
          siteLocation: 'Standort',
          updates: 'Updates',
          more: 'Mehr',
          mismatchErrorTitle: 'Arbeitsauftrag-Fehler',
          mismatchErrorMessage:
            'Der Arbeitsauftrag, auf den Sie zugreifen möchten, stimmt nicht mit dem überein, bei dem Sie derzeit eingecheckt sind. Bitte überprüfen Sie Ihren Arbeitsauftrag und versuchen Sie es erneut.',
          siteDocuments: 'Standortdokumente',
          validFrom: 'Gültig ab',
          validUntil: 'Gültig bis',
          documentName: 'Dokumentname',
          documentType: 'Dokumenttyp',
          attachments: 'Arbeitsauftrag-Dateien',
          download: 'Herunterladen',
          workDetails: 'Arbeitsdetails',
        },
        engineers: {
          assistants: {
            addAssistantEngineer: 'Hilfsingenieur hinzufügen',
            assistantEngineers: 'Hilfsingenieure',
            description:
              'Bitte geben Sie aus Sicherheitsgründen die Namen aller Ingenieure vor Ort an.',
            editMainEngineer: 'Hauptingenieur bearbeiten',
            errors: {
              creatingEngineer: 'Fehler beim Erstellen des Ingenieurs',
              creatingSession: 'Fehler beim Erstellen der Sitzung',
            },
            header: 'Ingenieure vor Ort',
            mainEngineer: 'Hauptingenieur',
            newAssistantEngineer: 'Vollständigen Namen eingeben',
            next: 'Weiter',
            removeEngineer: 'Ingenieur entfernen',
            selectExistingAssistantEngineer: 'Geben Sie den Namen ein',
          },
          index: {
            description:
              'Bitte geben Sie aus Sicherheitsgründen die Namen aller Ingenieure vor Ort an.',
            errorCreatingEngineer:
              'Fehler beim Erstellen des Ingenieurs, bitte versuchen Sie es erneut.',
            header: 'Ingenieure vor Ort',
            hintMainEngineer: 'Vollständigen Namen des Hauptingenieurs eingeben',
            newMainEngineer: 'Neuer Hauptingenieur',
            next: 'Weiter',
            selectExistingMainEngineer: 'Vorhandenen Hauptingenieur auswählen',
            yes: 'Ja',
            no: 'Nein',
            mainEngineerLabel: 'Sind Sie der Hauptingenieur?',
          },
        },
        index: {
          callUsOn: 'Rufen Sie uns an unter {phoneNumber}',
          description: 'Können Sie nicht finden, was Sie suchen?',
          dueBy: 'Fälligkeitsdatum',
          header: 'Arbeitsauftrag auswählen',
          notAvailable: 'Nicht verfügbar',
          searchWorkOrders: 'Arbeitsaufträge suchen...',
        },
        manageEngineers: {
          manageEngineers: 'Ingenieure verwalten',
          notWorking: 'Inaktive Arbeiter',
          pause: 'Pausieren',
          resume: 'Fortsetzen',
          workingNow: 'Aktive Arbeiter',
          startTime: 'Startzeit',
          endTime: 'Endzeit',
          duration: 'Dauer',
        },
        startWorkChecks: {
          feedback: {
            feedbackTitle: 'Feedback',
            feedbackDescription:
              'Bitte geben Sie Feedback zum Arbeitsauftrag, um unseren Service zu verbessern.',
            feedbackLabel: 'Feedback',
            filesLabel: 'Anhänge',
            submissionLabel: 'Feedback absenden',
          },
          hazards: {
            back: 'Zurück',
            hazards: 'Gefahren',
            next: 'Weiter',
            no: 'Nein',
            noTasksForHazard: 'Für diese Gefahr sind keine Aufgaben zu erledigen.',
            yes: 'Ja',
          },
          induction: {
            continue: 'Weiter',
            induction: 'Einweisung',
          },
          index: {
            checkIn: 'Einchecken',
            description:
              'Bitte führen Sie die folgende Risikobewertung für die ausgewählte Arbeit durch.',
            fail: 'Fehler bei der Bearbeitung der Startarbeitsprüfungen.',
            haltMessage:
              'Potenzielle Risiken erkannt. Bitte Arbeit einstellen, Sicherheitsrichtlinien prüfen und Ihren Vorgesetzten kontaktieren.',
            header: 'Startarbeitsprüfungen',
            endVisit: 'Besuch beenden',
            leaveFeedback: 'Feedback hinterlassen',
          },
          safeToProceed: {
            continue: 'Weiter',
            safeToProceed: 'Sicher fortzufahren',
          },
        },
      },
    },
    index: {
      title: 'Willkommen',
      description: 'Scannen Sie den QR-Code an Ihrem Standort, um zu beginnen.',
    },
    login: {
      errorTitle: 'Unerwarteter Fehler',
      errorMessage:
        'Ein unerwarteter Fehler ist aufgetreten. Bitte versuchen Sie erneut, den QR-Code zu scannen.',
    },
    unauthenticated: {
      welcome: {
        title: 'Willkommen bei {site}',
        description:
          'Bevor wir Ihnen Arbeitsaufträge anzeigen können, müssen wir Ihre Daten verifizieren. Klicken Sie auf die Schaltfläche unten, um fortzufahren.',
        next: 'Weiter',
      },
      index: {
        errorTitle: 'Unerwarteter Fehler',
        errorMessage:
          'Ein unerwarteter Fehler ist aufgetreten. Bitte versuchen Sie erneut, den QR-Code zu scannen.',
      },
      contractor: {
        title: 'Für wen arbeiten Sie?',
        contractor: 'Auftragnehmer',
        contractorLabel: 'Geben Sie Ihren Firmennamen ein',
        contractorHint: 'Sie müssen mindestens 3 Zeichen eingeben, um Ergebnisse zu sehen',
        defaultSelectPlaceholder: '--Bitte auswählen--',
        next: 'Weiter',
      },
      user: {
        title: 'Wer sind Sie?',
        cancel: 'Abbrechen',
        createNewUserLabel: 'Mein Name ist nicht aufgeführt',
        existingUserLabel: 'Geben Sie Ihren Namen ein',
        existingUserHint: 'Sie müssen mindestens 3 Zeichen eingeben, um Ergebnisse zu sehen',
        newUserLabel: 'Geben Sie Ihren vollständigen Namen ein',
        next: 'Weiter',
        user: 'Benutzer',
      },
      verification: {
        methods: {
          add: {
            add: 'Verifizierungsmethode hinzufügen',
            defaultSelectPlaceholder: '--Bitte auswählen--',
            emailLabel: 'E-Mail',
            existingMethodWarning:
              'Sie haben bereits eine ausstehende Anfrage für diese Verifizierungsmethode, die auf die Genehmigung des Administrators wartet. Das Hinzufügen einer neuen überschreibt diese.',
            method: 'Methode',
            methodLabel: 'Methode',
            mobileCountryHint: 'Bitte wählen Sie Ihre Ländervorwahl',
            mobileCountryLabel: 'Ländervorwahl Mobil',
            mobileHint: 'Bitte geben Sie Ihre Handynummer ein',
            mobileLabel: 'Mobil',
            title: 'Verifizierungsmethode hinzufügen',
          },
          confirm: {
            confirm: 'Bestätigen',
            description: 'Bitte bestätigen Sie Ihre Verifizierungsmethode, um fortzufahren.',
            label: 'Geben Sie Ihren Code ein',
            resend: 'Erneut senden',
            resendPrompt: 'Keinen Code erhalten?',
            title: 'Verifizierungsmethode bestätigen',
          },
          confirmed: {
            description:
              'Sie werden benachrichtigt, sobald diese Verifizierungsmethode von Ihrem Administrator genehmigt wurde. Dann können Sie sie zur Identitätsprüfung verwenden.',
            forceApproval: 'Bis zur Genehmigung haben Sie keinen Zugriff auf Arbeitsaufträge.',
            nonForceApproval:
              'In der Zwischenzeit können Sie mit eingeschränktem Zugriff auf Arbeitsaufträge zugreifen.',
            nonForceApprovalButtonLabel: 'Mit eingeschränktem Zugriff fortfahren',
            title: 'Warten auf Genehmigung',
          },
          addNew: 'Neue Verifizierungsmethode hinzufügen',
          description:
            'Wir müssen Ihre Identität verifizieren, um Ihnen vollen Zugriff auf den Arbeitsauftrag zu gewähren.',
          email: 'E-Mail',
          hint: 'Wir senden einen Link an Ihre ausgewählte Verifizierungsmethode, der Ihnen vollen Zugriff auf den Arbeitsauftrag gibt. Wenn Sie eine bestehende Verifizierungsmethode ändern müssen, wenden Sie sich bitte an Ihren Administrator.',
          label: 'Verifizierungsmethode auswählen',
          next: 'Weiter',
          pendingHint: 'Warten auf Genehmigung durch Ihren Administrator',
          sms: 'SMS',
          title: 'Verifizierung',
        },
        optional: {
          hint: 'Die Verifizierung Ihrer Benutzerdaten gibt Ihnen vollen Zugriff auf den Arbeitsauftrag',
          label: 'Möchten Sie Ihre Benutzerdaten verifizieren?',
          next: 'Weiter',
          no: 'Nein',
          noHint:
            'Ich möchte meine Benutzerdaten nicht verifizieren und mit eingeschränktem Zugriff auf den Arbeitsauftrag fortfahren',
          title: 'Verifizierung',
          yes: 'Ja',
          yesHint:
            'Ich möchte meine Benutzerdaten verifizieren und vollen Zugriff auf den Arbeitsauftrag erhalten',
        },
        sent: {
          description:
            'Ein Login-Link wurde an {identifier} gesendet. Bitte klicken Sie auf den Link, um Ihre Anmeldung abzuschließen.',
          title: 'Login-Link gesendet',
        },
      },
    },
  },
  utils: {
    getActivityLog: {
      yesterday: 'Gestern',
      today: 'Heute',
      days: {
        monday: 'Montag',
        tuesday: 'Dienstag',
        wednesday: 'Mittwoch',
        thursday: 'Donnerstag',
        friday: 'Freitag',
        saturday: 'Samstag',
        sunday: 'Sonntag',
      },
      months: {
        january: 'Januar',
        february: 'Februar',
        march: 'März',
        april: 'April',
        may: 'Mai',
        june: 'Juni',
        july: 'Juli',
        august: 'August',
        september: 'September',
        october: 'Oktober',
        november: 'November',
        december: 'Dezember',
      },
    },
  },
  composables: {
    useRedirectToError: {
      title: 'Etwas ist schiefgelaufen',
      message: 'Bitte versuchen Sie erneut, den QR-Code zu scannen.',
    },
    useResolveWorkOrderEvents: {
      user: {
        unknown: 'Unbekannter Benutzer',
      },
      none: 'Keine',
      types: {
        stateTransition: 'Status geändert',
        contractorAssigned: 'Auftragnehmer zugewiesen',
        engineerAssigned: 'Ingenieur zugewiesen',
        serviceAssigned: 'Service zugewiesen',
        priorityChanged: 'Priorität geändert',
        actionableDateChanged: 'Maßnahmendatum geändert',
        dueDateChanged: 'Fälligkeitsdatum geändert',
        etaDateChanged: 'Voraussichtliches Ankunftsdatum geändert',
        spendLimitApproved: 'Ausgabenlimit genehmigt',
        spendLimitCancelled: 'Anfrage für Ausgabenlimit storniert',
        spendLimitRejected: 'Ausgabenlimit abgelehnt',
        spendLimitRequested: 'Ausgabenlimit angefragt',
        jobSheetUploaded: 'Arbeitsblatt hochgeladen',
        slaAlertSent: 'Zeit zur Teilnahme SLA-Alarm überschritten',
        issuedWorkPermit: 'Arbeitserlaubnis ausgestellt',
        requestForServiceSent: 'Serviceanfrage gesendet',
        comment: 'Kommentar hinzugefügt',
        unknown: 'Unbekanntes Ereignis',
      },
      labels: {
        actionableDate: 'Maßnahmendatum',
        comment: 'Kommentar',
        file: 'Datei',
        contractor: 'Auftragnehmer',
        dueDate: 'Fälligkeitsdatum',
        etaDate: 'Voraussichtliches Ankunftsdatum',
        engineer: 'Ingenieur',
        priority: 'Priorität',
        requestForService: 'Serviceanfrage',
        service: 'Service',
        spendLimit: 'Ausgabenlimit',
        status: 'Status',
        workPermit: 'Arbeitserlaubnis',
      },
    },
  },
}
